module.exports = __webpack_public_path__ + "media/images/Blue Mountains Hero-3c1996c4.jpg";